import { Component, OnInit, ViewChild } from '@angular/core';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import {  DataStateChangeEvent, ExcelExportEvent, GridComponent } from '@progress/kendo-angular-grid';
import { Nomenclatures } from '~/app/core/common/enums/Nomenclatures';
import { CompositeFilterDescriptor, State, orderBy, process } from '@progress/kendo-data-query';
import { StoreListService } from '~/app/core/common/services/store-list.service';
import { ProfileService } from '~/app/core/common/services/profile.service';
import { DialogHelperComponent } from '~/app/shared/helpers/dialog-helper';
import { ProfileCategoriesService } from '~/app/core/common/services/profile-categories.service';
import { ProfileItem } from '~/app/core/common/models/profileItem';
import { OrderItemService } from '~/app/core/common/services/order-item.service';
import {fileExcelIcon, filePdfIcon, SVGIcon} from "@progress/kendo-svg-icons";
import { filter } from 'rxjs';
@Component({
  selector: 'app-orderguide-worksheet',
  templateUrl: './orderguide-worksheet.component.html',
  styleUrls: ['./orderguide-worksheet.component.scss']
})
export class OrderguideWorksheetComponent implements OnInit {

  public filter: CompositeFilterDescriptor;
  public gridData: Array<any>= [];
  public loading = false;
  public selection: string[] = [];
  selectedRow: Array<any> = [];
  public items: ProfileItem[] = [];
  public today: number;
  public state: State = {
    skip: 0,
    take: 60,
    filter: {
      logic: "or",
      filters: [],
    }
  };
  Nomenclatures = Nomenclatures;
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;

  constructor(private _storeListService: StoreListService,
    public _profileService: ProfileService,
    public dialogHelper: DialogHelperComponent,
    public profileCategoriesService: ProfileCategoriesService,
    public orderItemService: OrderItemService,
    public storeListService: StoreListService,
  ) {
   this.exportAllData = this.exportAllData.bind(this);
  }

  ngOnInit() {
    this.today = Date.now();
    this.loadItems();
  }

  /** Get Items method*/
  async loadItems() {
    this.loading=true;
    this.gridData = (await this.orderItemService.downloadAllItemsByStoreNumber(this.storeListService.pickedCustomerId.toString(), '-1')).filter((items)=> items.showIndicator == true);
    this.loading=false;
    }


  /** Export Pdf and Excel Methods */
  public exportAllData(): ExcelExportData {
    
     /** Below code check if the gird data is filtered or not */
     const hasFilters = this.state.filter && this.state.filter.filters && this.state.filter.filters.length > 0;

    const result: ExcelExportData = {
      data: hasFilters ? process(this.gridData, this.state).data : this.gridData,
    };
    return result;
  }

  exportToPDF(orderguideGrid : GridComponent) {
    try {
      this.loading = true;
      setTimeout(() => {
        orderguideGrid.saveAsPDF();
        this.loading = false;
      }, 100);
    } catch (ex) {
      this.dialogHelper.showConfirmDialogOkOnly('Problem', 'There was a problem exporting this worksheet, please try again later').then();
      this.loading = false;
    }
  }

  exportToExcel(orderguideGrid : GridComponent) {
    try {
      this.loading = true;
      setTimeout(() => {
        orderguideGrid.saveAsExcel();

        this.loading = false;
      }, 100);
    } catch (ex) {
      this.dialogHelper.showConfirmDialogOkOnly('Error', 'There was a problem exporting this worksheet, please try again later').then();
      this.loading = false;
    }

  }

  public onChange(state: DataStateChangeEvent): void {
    this.state = state;
  }

  excelExported($event: ExcelExportEvent) {
    const sheet = $event.workbook.sheets[0];
    sheet.freezePane.rowSplit = 0;
    sheet.name = 'OrderGuideWorksheet';
  }
}
